function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTasksLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.89,4V2a1,1,0,0,0-1-1H1.45A.28.28,0,0,0,1.3,1a.35.35,0,0,0-.16.46,2.3,2.3,0,0,1,.25,1.06v.88A2.3,2.3,0,0,1,1.14,4.5a.4.4,0,0,0,0,.15A.34.34,0,0,0,1.45,5H17.89A1,1,0,0,0,18.89,4Z",
    style: {
      fill: "#4d94ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.89,6H5.57A.47.47,0,0,0,5.4,6a.46.46,0,0,0-.26.59,3.45,3.45,0,0,1,.25,1.3V9.08a3.45,3.45,0,0,1-.25,1.3.46.46,0,0,0,.43.62H20.89a2,2,0,0,0,2-2V8A2,2,0,0,0,20.89,6Z",
    style: {
      fill: "#3b7ff5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.89,15V14a2,2,0,0,0-2-2H3.57a.47.47,0,0,0-.17,0,.46.46,0,0,0-.26.59,3.45,3.45,0,0,1,.25,1.3v1.16a3.45,3.45,0,0,1-.25,1.3.46.46,0,0,0,.43.62H18.89A2,2,0,0,0,20.89,15Z",
    style: {
      fill: "#4d94ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.89,18H4.57a.47.47,0,0,0-.17,0,.46.46,0,0,0-.26.59,3.45,3.45,0,0,1,.25,1.3v1.16a3.45,3.45,0,0,1-.25,1.3.46.46,0,0,0,.43.62H19.89a2,2,0,0,0,2-2V20A2,2,0,0,0,19.89,18Z",
    style: {
      fill: "#3b7ff5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksLight);
export default __webpack_public_path__ + "static/media/tasks-light.5b9ca90b53b7d65fd653186556f0b52e.svg";
export { ForwardRef as ReactComponent };